var React = require('react');

function SliderArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:10;}\r\n"),React.createElement("path",{"id":"arrow_copy_2","className":"st0","d":"M18.3,30.7L5,17.8L18.3,5","key":1})]);
}

SliderArrowLeft.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 30.3 35.7","style":{"enableBackground":"new 0 0 30.3 35.7"},"xmlSpace":"preserve"};

module.exports = SliderArrowLeft;

SliderArrowLeft.default = SliderArrowLeft;
